/**
 * Points déjà enregistrés pour MapPicker (repères des emplacements, relais, équipements existants).
 * À part de MapPicker : les tests simulent MapPicker sans ces aides.
 */

/** Point déjà enregistré, affiché pour repère (pas déplaçable) : on voit ce qui existe avant d'ajouter. */
export interface MapPickerExistingPoint {
  id: number | string
  lat: number
  lng: number
  label?: string | null
}

/** Points existants d'une liste (location { lat, lng } nullable), pour MapPicker. */
export function existingPointsOf<T extends { id: number; location: { lat: number | null; lng: number | null } }>(
  items: T[],
  label: (item: T) => string | null | undefined,
): MapPickerExistingPoint[] {
  return items
    .filter((i) => i.location?.lat != null && i.location?.lng != null)
    .map((i) => ({ id: i.id, lat: i.location.lat as number, lng: i.location.lng as number, label: label(i) }))
}
